'use client';

// SP 현장 도크의 클라이언트 섬 — 계측(노출·클릭)만 갖는다. 기하·색은 components.css .kd-site-dock.
// ⚠️ 인라인 style 없음(display 금지 규율 — TalkFab 주석 참조).
// ⚠️ 새 이벤트명을 만들지 않는다 — 카톡은 trackTalkClick('dock')(event_name bujeonggong_talk). 슬롯만 더했다.
// ⚠️ 상세 링크 = 리드 퍼널 클릭(trackLeadClick('dock')) — #lead-form 딥링크가 붙는 현장(leadFormAvailable)만.
//    미적격 현장은 계측 없이 착지 URL 의 utm_medium=site_dock 으로만 식별한다(SP-2 §6 · 리드 축에 비리드 클릭을 섞지 않는다).

import { KAKAO_TALK_URL, trackTalkClick } from '@/lib/talk-banner';
import { useTalkView } from '@/components/banner/useTalkView';
import { trackLeadClick } from '@/lib/apt/lead-track';
import { TalkLiveLabel } from '@/components/live/LiveBadge';

export default function SiteDockClient({ siteSlug, detailHref, leadFormAvailable }: { siteSlug: string; detailHref: string; leadFormAvailable: boolean }) {
  const talkRef = useTalkView<HTMLAnchorElement>('dock', { site_slug: siteSlug });

  return (
    <>
      <a
        href={detailHref}
        className="kd-site-dock__btn kd-site-dock__btn--detail"
        onClick={leadFormAvailable ? () => trackLeadClick('dock', { site_slug: siteSlug }) : undefined}
      >
        상세페이지
      </a>
      <a
        ref={talkRef}
        href={KAKAO_TALK_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="kd-site-dock__btn kd-site-dock__btn--talk kd-lv-host"
        onClick={() => trackTalkClick('dock', { site_slug: siteSlug })}
      >
        {/* nav-live(2026-10-24) — 「카톡방 입장」 → 「실시간 소통」 + LIVE 표지(상세 하단 바와 같은 한 벌). */}
        <TalkLiveLabel />
      </a>
    </>
  );
}
